import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { useDeleteGovernmentAllocationEntryProductCategory } from '@/features/governmentAllocations/hooks/useDeleteGovernmentAllocationEntryProductCategory'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2Icon } from 'lucide-react'
import { useState } from 'react'

interface DeleteEntryProductCategoryModalProps {
  governmentAllocationId: string
  entryProductCategoryId: string
  disabled: boolean
}

export const DeleteEntryProductCategoryModal = ({
  governmentAllocationId,
  entryProductCategoryId,
  disabled,
}: DeleteEntryProductCategoryModalProps) => {
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const onSuccess = () => {
    setIsOpen(false)
    queryClient.invalidateQueries({ queryKey: ['governmentAllocation', governmentAllocationId] })
    queryClient.invalidateQueries({ queryKey: ['clientCompanyBranchAvailableToAllocateSummary'] })
  }

  const { mutate: deleteEntryProductCategory, isPending: deleteEntryProductCategoryIsPending } =
    useDeleteGovernmentAllocationEntryProductCategory({
      governmentAllocationId,
      onSuccess,
      onError: (error) => {
        setIsOpen(false)

        const { errors } = error?.response?.data as { errors: Record<string, string[]> }

        if (errors.base) {
          setMessages(errors.base)
        }
      },
    })

  return (
    <>
      <Modal
        Trigger={
          <Button type="button" variant="outline-error" className="h-10 w-auto p-0">
            <Trash2Icon strokeWidth={1} />
          </Button>
        }
        triggerDisabled={disabled}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Você tem certeza?"
        showClose={false}
        useCancellableFooter
        confirmButtonText="Remover Serviço"
        disabled={deleteEntryProductCategoryIsPending}
        confirmButtonIsLoading={deleteEntryProductCategoryIsPending}
        onConfirm={() => deleteEntryProductCategory(entryProductCategoryId)}
      />

      {messages && <ModalMessageSimple messages={messages} setMessages={setMessages} isError />}
    </>
  )
}
